import { useEffect, useState } from 'react';

/** Al cambiar el valor ya debounced, la página vuelve a 1 en el mismo render. */
export function useDebouncedSearch(initial = '') {
  const [value, setValue] = useState(initial);
  const debounced = useDebouncedValue(value, 300);
  const [page, setPage] = useState(1);
  const [linked, setLinked] = useState(debounced);
  if (linked !== debounced) {
    setLinked(debounced);
    setPage(1);
  }
  return {
    value,
    setValue,
    debounced,
    page: linked === debounced ? page : 1,
    setPage,
  };
}

/** Espera `delayMs` para propagar el valor. Un string vacío se aplica al instante. */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    if (typeof value === 'string' && value.trim() === '') {
      setDebounced(value);
      return;
    }

    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
